module.exports = __webpack_public_path__ + "935b362b1433fdddafe8f07388672918.pdf";